<div [style.height.vh]="68" [style.width.vw]="80">
  <gstar-editor
    [title]="data().title"
    [content]="data().content | blankLinks | safe: 'html'"
    [mode]="data().readonly ? dataModes.readonly : dataModes.edition"
    (update)="updateHandler($event)" />
</div>
